import React from 'react';
import { css } from '@emotion/react';
import { Header } from 'screens/booker/components/Header';
import { Heading } from 'screens/booker/components/Heading';

export const AccountLayout = ({ children }) => {
	return (
		<div
			css={css`
				width: 100%;
			`}
		>
			<Header>
				<Heading
					left={
						<h1
							css={css`
								font-size: 24px;
								line-height: 36px;
								font-weight: normal;
								margin-bottom: 0;
							`}
						>
							Nastavení účtu
						</h1>
					}
				/>

				<div
					css={css`
						display: flex;
					`}
				>
					{/* <TabLink horizontal to={routes.booker.account}>
						E-mail
					</TabLink>
					<TabLink horizontal to={routes.booker.accountPassword}>
						Heslo
					</TabLink>
					<TabLink horizontal to={routes.booker.accountOrganization}>
						Organizace
					</TabLink> */}
				</div>
			</Header>

			{children}
		</div>
	);
};
